import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/fusion/fusion/apps/frontend/src/app/[domain]/[lang]/authentication/(login)/layout.tsx");
